import { render, staticRenderFns } from "./adv-resource.vue?vue&type=template&id=eccc3ca4&scoped=true&lang=pug&"
import script from "./adv-resource.vue?vue&type=script&lang=js&"
export * from "./adv-resource.vue?vue&type=script&lang=js&"
import style0 from "./adv-resource.vue?vue&type=style&index=0&id=eccc3ca4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccc3ca4",
  null
  
)

export default component.exports